import React, { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  Paper,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useParams, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import AddPocForm from '../AddPoc/AddPocForm.jsx';
import FilePreviewSingle from '../Shared/FileUploadPreview/FilePreviewSingle';
import FileInput from '../Shared/FileUploadPreview/FileInput';
import SweetAlert from '../Shared/Notification';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions';
import { ConstantActions } from '../../Services/_actions/constant.actions';
import { supplierListAtom, stateListAtom, addPocFormAtom } from '../../Services/_states';
import { isValidPhoneNumber } from '../../utils/helper';
import OrganisationDropdown from '../Shared/OrganisationDropdown/index.tsx';
import TableHeader from '../Shared/TableHeader';
import { BackButton } from '../Shared/BackButton';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';

export const AddUpdateSupplierModal1 = () => {
  const actions = InterveneActions();
  const constantActions = ConstantActions();
  const { phone_number } = useParams();
  const navigation = useNavigate();

  const supplierTypeList = useRecoilValue(supplierListAtom);
  const stateList = useRecoilValue(stateListAtom);
  const [addPocFormData] = useRecoilState(addPocFormAtom);

  const [formData, setFormData] = useState({
    phone_number: '',
    address: '',
    area: '',
    city: '',
    state_name: '',
    pin_code: '',
    latitude: '',
    longitude: '',
    unit_primary_count: '',
    unit_secondary_count: '',
    supplier_id: '',
    supplier_name: '',
    supplier_type: '',
    representative: '',
    relationship_manager: '',
  });

  const [supplierList, setSupplierList] = useState([]);
  const [organisationList, setOrganisationList] = useState([]);
  const [agencyUsers, setAgencyUsers] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [societyImages, setSocietyImages] = useState([]);
  const [selectImage, setSelectImage] = useState(null);
  const [accordianKey, setAccordianKey] = useState('0');
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAddNewSociety, setIsAddNewSociety] = useState(false);
  const [errors, setErrors] = useState({});
  const { showSnackBar } = useSnackBar();

  const handleSearch = async (value) => {
    setFormData((prev) => ({ ...prev, phone_number: value }));
    if (isValidPhoneNumber(value)) {
      const res = await actions.getSupplierByNumber(value);
      setSupplierList(res);
    }
  };

  const getSocietyImages = async (dataObj) => {
    const res = await actions.getSocietyImages(dataObj);
    setSocietyImages(res);
  };

  const getSupplierData = async ({ supplier_id }) => {
    const res = await actions.getSupplierDetails(supplier_id);
    if (res?.supplier?.[0]?.[0]) {
      const supplier = res.supplier[0][0];
      const newFormData = { ...formData, ...supplier };
      setFormData(newFormData);
      getSocietyImages(supplier);

      if (res?.state?.id) await handleSelectState(res.state);
      if (res?.city?.id) await handleSelectCity(res.city);
      if (res?.area_id?.id) setFormData((prev) => ({ ...prev, area: res.area_id.label }));
      if (supplier.representative)
        await handleSelectSupplierAgency({ organisation_id: supplier.representative });
    }
  };

  const handleSelectState = async (selected) => {
    const cityRes = await constantActions.getCityByState(selected.id);
    setCityList(cityRes);
    setAreaList([]);
    setFormData((prev) => ({
      ...prev,
      state_name: selected.state_name,
      city: '',
      area: '',
    }));
  };

  const handleSelectCity = async (selected) => {
    const areaRes = await constantActions.getAreaByCity(selected.id);
    setAreaList(areaRes);
    setFormData((prev) => ({ ...prev, city: selected.city_name, area: '' }));
  };

  const handleSelectArea = (selected) => {
    setFormData((prev) => ({ ...prev, area: selected.label }));
  };

  const handleSelectSupplierAgency = async (selected) => {
    const res = await constantActions.getUserMinimalList(selected.organisation_id);
    setFormData((prev) => ({ ...prev, representative: selected.organisation_id }));
    setAgencyUsers(res);
  };

  // const onFileSelect = (e) => {
  //   const selected = e.target.files[0];
  //   setSelectImage(selected);
  // };

  const onFileSelect = (e) => {
    const selected = e.target.files[0];
    if (selected && selected.type.startsWith('image/')) {
      setSelectImage(selected);
    } else {
      showSnackBar('Only image files are allowed.', 'error');
      e.target.value = '';
      setSelectImage(null);
    }
  };

  const onFileRemove = () => setSelectImage(null);

  // const onFileUpload = async () => {
  //   if (selectImage && formData.supplier_id) {
  //     const my_filename = `MD_${formData.supplier_id}${selectImage.name}${Date.now()}`;
  //     const updatedFile = new File([selectImage], my_filename, { type: selectImage.type });
  //     await constantActions.uploadFileS3Bucket(updatedFile);
  //     await actions.postSoceityImages({
  //       location_id: formData.supplier_id,
  //       image_url: my_filename,
  //       object_id: formData.supplier_id,
  //       supplierType: formData.supplier_type
  //     });
  //     const imgs = await actions.getSocietyImages(formData);
  //     setSocietyImages(imgs);
  //   }
  // };

  const onFileUpload = async () => {
    if (selectImage && formData.supplier_id) {
      const formDataToUpload = new FormData(); 
      formDataToUpload.append('file', selectImage);

      try {
        const resp = await constantActions.uploadFileS3Bucket(formDataToUpload);

        if (resp?.status === 200 && resp?.data?.data) {
          const fileLink = resp?.data?.data?.url ?? '';
          const fileName = resp?.data?.data?.filename ?? '';

          await actions.postSoceityImages({
            location_id: formData.supplier_id,
            image_url: fileLink,
            object_id: formData.supplier_id,
            supplierType: formData.supplier_type,
          });

          const imgs = await actions.getSocietyImages(formData);
          setSocietyImages(imgs);
        } else {
          console.log('File upload failed: ', resp);
        }
      } catch (error) {
        console.log('Error during file upload:', error);
      }
    }
  };

  const deleteImage = async (file) => {
    const res = await actions.deleteSocietyImages(file);
    if (res.status === 200) {
      setSocietyImages((prev) => prev.filter((img) => img.id !== file.id));
    }
  };

  const addUpdateSupplier = async () => {
    const res = await actions.postSupplierData({ ...formData, poc: addPocFormData });
    if (res?.status === 200) {
      SweetAlert(res?.data?.data?.message, 'success');
    } else if (res?.status === 400 && res?.data?.data?.general_error?.Message) {
      SweetAlert(res?.data?.data?.general_error?.Message, 'warning');
    } else {
      SweetAlert('Server Error', 'error');
    }
  };

  useEffect(() => {
    if (phone_number === 'null' || !phone_number) setIsEditMode(true);
    else handleSearch(phone_number);
    constantActions.getStateList();
    constantActions.getOrganisations().then(setOrganisationList);
    actions.getSupplierList();
  }, []);

  const backButton = () => {
    return <BackButton onClick={() => navigation(-1)} />;
  };

  return (
    <>
      <Paper elevation={3} sx={{ p: 2 }}>
        <TableHeader
          headerValue={`${isEditMode ? 'Add' : 'Update'} Supplier`}
          isBackButton={backButton}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={3} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label={
                <Typography component="span">
                  Phone Number<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              size="small"
              value={formData.phone_number}
              onChange={(e) => handleSearch(e.target.value)}
              disabled={!isEditMode}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <FormControl fullWidth>
              <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
                Select Society <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={isAddNewSociety}
                      onChange={() => setIsAddNewSociety(!isAddNewSociety)}
                    />
                  }
                  label="Add New"
                  sx={{ ml: 2 }}
                />
              </Typography>
              {!isAddNewSociety ? (
                <SearchableDropdown
                  options={supplierList.map((s) => ({
                    label: s.supplier_name,
                    value: s.supplier_id,
                  }))}
                  value={supplierList.find((s) => s.supplier_id === formData.supplier_id) || null}
                  onChange={(selected) => {
                    if (selected) {
                      setFormData((prev) => ({ ...prev, supplier_id: selected.value }));
                      getSupplierData({ supplier_id: selected.value });
                    }
                  }}
                  label={
                    <Typography component="span">
                      Select Society<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                    </Typography>
                  }
                  //     label=""
                  placeholder="Select Society"
                />
              ) : (
                <TextField
                  label="Enter Society"
                  size="small"
                  fullWidth
                  value={formData.supplier_name || ''}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      supplier_name: e.target.value,
                      supplier_id: '',
                    }))
                  }
                />
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={3} sx={{ mt: 3 }}>
            <SearchableDropdown
              options={supplierTypeList.map((s) => ({ label: s.label, value: s.value }))}
              value={supplierTypeList.find((s) => s.value === formData.supplier_type) || null}
              onChange={(selected) =>
                setFormData((prev) => ({ ...prev, supplier_type: selected.value }))
              }
              // label="Supplier Type"
              label={
                <Typography component="span">
                  Supplier Type<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              placeholder="Supplier Type"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3} sx={{ mt: 3 }}>
            <SearchableDropdown
              options={stateList.map((s) => ({ label: s.state_name, value: s.id, ...s }))}
              value={
                stateList
                  .map((s) => ({ label: s.state_name, value: s.id }))
                  .find((opt) => opt.label === formData.state_name) || null
              }
              onChange={handleSelectState}
              label={
                <Typography component="span">
                  State<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              //   label="State"
              placeholder="Select State"
            />
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6} lg={3}>
            <SearchableDropdown
              options={cityList.map((c) => ({ label: c.city_name, value: c.id, ...c }))}
              value={
                cityList
                  .map((c) => ({ label: c.city_name, value: c.id }))
                  .find((opt) => opt.label === formData.city) || null
              }
              onChange={handleSelectCity}
              // label="City"
              label={
                <Typography component="span">
                  City<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              placeholder="Select City"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <SearchableDropdown
              options={areaList.map((a) => ({ label: a.label, value: a.id }))}
              value={areaList.find((a) => a.label === formData.area) || null}
              onChange={handleSelectArea}
              label={
                <Typography component="span">
                  Address<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              placeholder="Select Area"
            />
          </Grid>

          {/* Edit Area (Disabled TextField) */}
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Edit Area"
              value={formData.area || ''}
              onChange={(e) => setFormData({ ...formData, area: e.target.value })}
              disabled
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label={
                <Typography component="span">
                  Address<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                </Typography>
              }
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Pin Code"
              value={formData.pin_code}
              onChange={(e) => {
                let value = e.target.value;
                value = value.replace(/\D/g, '');
                value = value.slice(0, 6);
                setFormData({ ...formData, pin_code: value });
              }}
              inputProps={{
                maxLength: 6,
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Latitude"
              value={formData.latitude}
              onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Longitude"
              value={formData.longitude}
              onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Primary Count"
              value={formData.unit_primary_count}
              onChange={(e) => setFormData({ ...formData, unit_primary_count: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              fullWidth
              size="small"
              label="Secondary Count"
              value={formData.unit_secondary_count}
              onChange={(e) => setFormData({ ...formData, unit_secondary_count: e.target.value })}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3} sx={{ mt: -2 }}>
            <OrganisationDropdown
              value={
                organisationList.find((org) => org.organisation_id === formData.representative) ||
                null
              }
              onChange={(selected) => handleSelectSupplierAgency(selected)}
              label="Supplier Agency"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <SearchableDropdown
              options={agencyUsers.map((u) => ({ label: u.username, value: u.username }))}
              value={
                agencyUsers
                  .map((u) => ({ label: u.username, value: u.username }))
                  .find((opt) => opt.value === formData.relationship_manager) || null
              }
              onChange={(selected) =>
                setFormData((prev) => ({ ...prev, relationship_manager: selected?.value }))
              }
              label="Agency User"
              placeholder="Select Agency User"
            />
          </Grid>

          <Grid item xs={12}>
            <Accordion expanded={accordianKey === '0'} onChange={() => setAccordianKey('0')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#e6f2ff' }}>
                <Typography>Poc Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <AddPocForm />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={accordianKey === '1'} onChange={() => setAccordianKey('1')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#e6f2ff' }}>
                <Typography>Society Images</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  {societyImages.map((file, idx) => (
                    <Grid item xs={12} sm={6} md={3} key={idx}>
                      <FilePreviewSingle
                        url={`${process.env.REACT_APP_IMAGE_URL}/${file.image_url}`}
                        name={file.name}
                        deleteFile={() => deleteImage(file)}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                    <FileInput
                      onFileSelect={onFileSelect}
                      onFileRemove={onFileRemove}
                      onFileUpload={onFileUpload}
                      file={selectImage}
                      setFile={setSelectImage}
                      accept="image/*"
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={addUpdateSupplier}>
              Add/Update Supplier
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
